<template>
  <a-modal
    title="收款信息"
    :visible="visible"
    :maskClosable="false"
    @ok="handleCancel"
    @cancel="handleCancel"
  >
    <div class="content">
      <div class="content-item">
        <span class="title">提现方式：</span>
        <span class="desc">{{ detail.pay_type_text }}</span>
      </div>
      <div class="content-item">
        <span class="title">收款账号：</span>
        <span class="desc">{{ detail.bank_account }}</span>
      </div>
      <div class="content-item">
        <span class="title">姓名：</span>
        <span class="desc">{{ detail.real_name }}</span>
      </div>
      <div class="content-item">
        <span class="title">提现金额：</span>
        <span class="desc">{{ detail.cash_amount }}</span>
      </div>
    </div>
    <template #footer>
      <a-button @click="handleCancel">关闭</a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  data () {
    return {
      // 详情
      detail: {},
      // 是否展示
      visible: false,
    }
  },
  methods: {
    // 显示
    showModal (record) {
      this.detail = record
      this.visible = true
    },
    // 关闭
    handleCancel () {
      // 隐藏
      this.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
.content-item {
  line-height: 26px;
  .title {
    font-size: 14px;
    color: #7A7A7A;
  }
  .desc {
    font-weight: 500;
    font-size: 14px;
    color: #5A5A5A;
  }
}
</style>
